<template>
    <div>
        <div class="card card-default shadow">
            <div class="card-header">
                <h4 class="card-title" style="width: 100%">
                    List
                    <!--<button v-on:click="AddNew()" type="button" class="btn bg-gradient-custom btn-sm"> <i class="fa fa-plus"> </i> Add New</button>-->
                </h4>
            </div>
            <div class="card-body">
                <div class="row">
                    <!--<div class="col-md-12">
                        <div class="form-group">
                            <label>Subject</label>
                            <select v-model="teacherID" class="form-control">
                                <option value="0">All</option>
                                <option v-for="item in courses" :value="item.TeacherCourseAllotmentID">{{item.CourseTitle}} - {{item.ClassName}}</option>
                            </select>
                        </div>
                    </div>-->

                    <div class="col-md-12">
                        <div class="form-group mt-2">
                            <div class="table-responsive text-left">
                                <table class="table table-bordered table-sm " id="tbl">
                                    <thead class="bg-custom">
                                        <tr>
                                            <th>Sr.</th>
                                            <th>Course</th>
                                            <th>Title</th>
                                            <th>Description</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,index) in files">
                                            <td>{{index + 1}}</td>
                                            <td>{{item.CourseTitle}} - {{item.ClassName}}</td>
                                            <td>{{item.Title}}</td>
                                            <td>{{item.Description}}</td>
                                            <td style="white-space: nowrap;">
                                                <button type="button" v-on:click="download(item.FileSharingID, item.Title + item.FileType)" class="btn bg-gradient-success btn-xs">Download</button>
                                                <!--<button type="button" class="btn bg-gradient-info btn-xs" v-on:click="edit(item.AssignmentID)">Edit</button>-->
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>const axios = require('axios').default;

    var table;

    export default ({

        data() {
            return {
                files: [],
            }
        },

        created: function () {
            this.pageLoad();
        },

        updated: function () {
            $('#tbl').DataTable();
        },

        methods: {
            pageLoad() {
                startReq();
                var vm = this;
                axios.post('/api/PortalApi/pageLoadFileUploadList')
                    .then(function (response) {
                        endReq();
                        vm.files = response.data.lst;
                    });
            },

            download(id, filename) {
                startReq()
                toastr.info("It may take some time, do not reload page");
                axios({
                    url: '/api/PortalApi/downloadFile?id=' + id,
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then((response) => {
                        if (response.status === 200) {
                            const url =
                                window.URL.createObjectURL
                                    (new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', filename);
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(url);
                            endReq();
                        } else {
                            endReq();
                            console.error('Error: Received non-200 status code');
                        }
                    })
                    .catch((error) => {
                        endReq();
                        console.error('Error downloading the image:', error);
                    });
            },
        },
    });</script>



// WEBPACK FOOTER //
// src/components/school/LMS/fileUploadList.vue